<template>
  <header>
    <div class="container">
      <div class="row justify-content-between align-items-center">
        <div class="col-3">
          <router-link
            style="text-decoration: none !important"
            :to="{ name: 'candidate-home' }"
          >
            <logo variant="dark" />
          </router-link>
        </div>
        <div
          class="col-9 d-flex align-items-center justify-content-end"
          style="margin-left: auto"
        >
          <ul class="menu">
            <li>
              <router-link :to="{ name: 'candidate-vacancies' }">
                Вакансії
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'candidate-tests' }">
                Тестування
              </router-link>
            </li>
          </ul>
          <b-button
            variant="primary"
            class="continue-setup"
            size="sm"
            v-if="!userData.setup_completed"
            style="margin-right: 30px"
            @click="resumeSetup"
            :class="{ show: showSetupBtn }"
          >
            Продовжити реєстрацію
          </b-button>
          <headerUser />
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import headerUser from "@/components/candidate/header-user.vue";
import logo from "@/components/header-logo.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    headerUser,
    logo,
  },
  data() {
    return {
      showSetupBtn: false,
    };
  },
  watch: {
    showSetup: {
      handler() {
        if (this.showSetup == true) {
          this.showSetupBtn = false;
        }
        if (this.showSetup == false) {
          setTimeout(() => {
            this.showSetupBtn = true;
          }, 500);
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      showSetup: "showSetup",
      userData: "userData",
    }),
  },
  methods: {
    resumeSetup() {
      this.$store.dispatch("toggleSetup", true);
    },
  },
  mounted() {
    setTimeout(() => {
      if (!this.userData.info) {
        this.resumeSetup();
      }
    }, 1000);

    if (this.showSetup == true) {
      this.showSetupBtn = false;
    }
    if (this.showSetup == false) {
      setTimeout(() => {
        this.showSetupBtn = true;
      }, 500);
    }
  },
};
</script>

<style lang="scss" scoped>
header {
  padding: 12px 0px;
  .continue-setup {
    height: 32px;
    visibility: hidden;
    transform: translateX(20px);
    opacity: 0;
    transition: 0.3s;
    &.show {
      visibility: visible;
      transform: 0px;
      opacity: 1;
      transition: 0.3s;
      transform: translateX(0px);
    }
  }
  .menu {
    display: flex;

    list-style: none;
    margin: 0;
    padding: 0;
    margin-right: auto;
    li {
      padding-right: 20px;
      a {
        color: var(--primary-color);
        font-weight: bold;
        text-decoration: none;
        display: block;
        padding: 4px 8px;
        transition: 0.3s;
        border-radius: 6px;
        &:hover {
          background: rgba(var(--bs-primary-rgb), 0.1);
          transition: 0.3s;
        }
        &.router-link-exact-active {
          background: rgba(var(--bs-primary-rgb), 0.1);
        }
      }
    }
  }
}
</style>
